import React from 'react'
import "./Loader.css"
import { CircularProgress } from '@material-ui/core'
const CaritraWidgetLoader = (props) => {
    const {height, width} = props
    return (
        <div className="CaritraWidgetLoaderContainer" style = {height&&width?{height:height, width:width}:{height:"100vh", width:"100%"}}>
            <CircularProgress/>
        </div>
    )
}

export default CaritraWidgetLoader

